module.exports = __webpack_public_path__ + "static/img/329_TO8_2537.f1ff6e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/329_TO8_2537.jpg
// module id = z2fL
// module chunks = 0